/* eslint-disable import/prefer-default-export */
import { createRoutine } from 'redux-saga-routines';
import { LIST_LOOKER_URLS, LIST_KEY_METRICS_URLS } from './types';

export const listLookerUrls = createRoutine(LIST_LOOKER_URLS);
export const listKeyMetricsUrls = createRoutine(LIST_KEY_METRICS_URLS);
